import { Typography } from 'core/Typography';
import Image from 'next/image';
import React from 'react';
import SectionWrapper from 'shared/SectionWrapper';

function Card({ title }: { title?: string }) {
    return (
        // eslint-disable-next-line max-len
        <div className="p-[12px] xl-desktop:p-[24px] bg-[#EEFCFF] border-[#11AFCC] rounded-[12px]  xl-desktop:rounded-[24px] border-[1px]">
            <Typography>{title}</Typography>
        </div>
    );
}

function Development() {
    return (
        <SectionWrapper>
            <div className="flex flex-col gap-[40px] lg-tablet:gap-[60px]">
                <div className="flex flex-col gap-[12px] mobile:gap-[16px] lg-tablet:gap-[24px]">
                    <Typography variant={'h3'}>Проверка гипотезы</Typography>
                    <Typography className="lg-tablet:max-w-8/12">
                        Мы взяли за основу классические методологии STAR и анализ поведенческих
                        индикаторов, написали под них систему промтов для ИИ-модели. Для проверки
                        гипотезы проанализировали 300 реальных интервью с кандидатами. Результаты,
                        полученные при помощи TalentMind, оказались на 87% ближе к эталонным
                        оценкам, чем при стандартном интервью.
                    </Typography>
                </div>
                <div className="flex flex-col gap-[12px] mobile:gap-[16px] lg-tablet:gap-[24px]">
                    <Typography variant={'h3'}>Разработка MVP</Typography>
                    <Typography className="lg-tablet:max-w-8/12">
                        Наша аналитическая модель объединила в себе три типа данных:
                    </Typography>
                    <div
                        className={
                            'flex flex-wrap gap-[12px] xl-desktop:gap-y-[24px] xl-desktop:gap-x-[40px]'
                        }
                    >
                        <Card title="Данные интервью с кандидатами" />
                        <Card title="Результаты ревью 360" />
                        <Card title="Результаты психометрических тестов" />
                    </div>
                    <Typography className="lg-tablet:max-w-8/12">
                        На этой базе мы построили классификатор из 10 ключевых навыков, применимый
                        к любым вакансиям.
                    </Typography>
                    <Typography className="lg-tablet:max-w-8/12">
                        После загрузки записи интервью TalentMind автоматически формирует понятный
                        отчёт и визуализирует сильные стороны и риски кандидата.
                    </Typography>
                </div>
                <div className="aspect-[1158/547] relative lg-tablet:max-w-10/12">
                    <Image
                        fill
                        src={`/images/pic/talent-mind/development.png`}
                        alt={'Калькулятор стоимости найма'}
                        objectFit={'contain'}
                    />
                </div>

                <Typography className="lg-tablet:max-w-8/12">
                    Корпоративные клиенты смогут интегрировать продукт с HR-системами и CRM по API,
                    чтобы результаты автоматически попадали в профиль кандидата и персональные
                    данные не передавались вовне. Это делает TalentMind безопасным и легко
                    масштабируемым.
                </Typography>
            </div>
        </SectionWrapper>
    );
}

export default Development;
